import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=2da9a6e6&scoped=true&"
import script from "./Favourite.vue?vue&type=script&lang=js&"
export * from "./Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9a6e6",
  null
  
)

export default component.exports